import {createReducer, on} from '@ngrx/store';
import {HistoriaNawigacji} from './historia-nawigacji';
import {aktualizujHistorieNawigacji} from './historia-nawigacji.actions';

export const initialHistoriaNawigacjiState: HistoriaNawigacji = {
  historia: []
}

export const historiaNawigacjiReducer = createReducer(
  initialHistoriaNawigacjiState,
  on(aktualizujHistorieNawigacji, (state, action) => {
    return {
      ...state,
      historia: action.historia
    }
  }),
);

